/** @format */

const Logo = (props) => <img alt='Logo' src='static/icon.svg' {...props} />;

export default Logo;
